import * as Yup from 'yup'

export const inviteSchema = Yup.object().shape({
  email: Yup.string()
    .email('Нужно ввети корректный email')
    .required('Нужно указать email'),
  direction: Yup.number().required('Нужно выбрать направление'),
  manager: Yup.number().required('Нужно выбрать мэнеджера'),
})
